import React, { forwardRef } from 'react';

import { Box, type BoxProps } from '@atlaskit/primitives';

export type ColProps = BoxProps<'col'>;

/**
 * __Col__
 *
 * A primitive table col container. Applies the HTML native element with no styling.
 *
 * @primitive
 */
export const Col = forwardRef<HTMLTableColElement, ColProps>(({ children, ...props }, ref) => {
	return (
		<Box as="col" ref={ref} {...props}>
			{children}
		</Box>
	);
});
